
<template>
  <div class="submit_box">
    <!-- <img :src="ModeType==1?refusePic:refuseVid" class="tip_img" /> -->
    <div class="tip1">拒绝原因</div>
    <div class="tip2">{{tip}}</div>
    <div class="flex2 double_btn">
      <div class="one" @click="commit(1)">关闭</div>
      <div class="two"  @click="commit(2)">修改问诊信息</div>
    </div>
  </div>
</template>

<script>
import refusePic from "@/images/refuse_pic.png"
import refuseVid from "@/images/refuse_vid.png"
export default {
    props:["tip","ModeType"],

    data(){
        return {
          refusePic,
          refuseVid
        }
    },
    methods:{
        commit(type){
            this.$emit("change",type)
        }
    }
}
</script>



<style lang="scss" scoped>
.submit_box {
  width:295px;
  min-height:210px;
  padding-bottom:28px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  position: fixed;
  left: 50%;
  top: 50%;
  text-align: center;
  padding-top: 40px;
  box-sizing: border-box;
   transform: translate(-50%, -50%);
  .tip1 {
    font-size:18px;
    font-family:STXihei;
    line-height: 18px;
    color:rgba(51,51,51,1);
    margin: 21px 0 12px 0;
  }
  .tip2 {
    padding: 0 34px;
    font-size: 13px;
    font-family:STXihei;
    color: rgba(153, 153, 153, 1);

  }
  .tip_img {
    width: 92px;
    height: 90px;
  }
 

  .one {
    width:110px;
    height:30px;
    border:1px solid #807AF4;
    border-radius: 13px;
    line-height: 30px;
    color: #807AF4;
    box-sizing: border-box;
    font-size:15px;
  }
  .two {
    width:110px;
    height:30px;
    background: #807AF4;
    border-radius: 13px;
    font-size: 11px;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin-left: 16px;
    font-size:15px;
  }
  .double_btn{
      justify-content: center;
      margin-top:40px;
      // position: absolute;
      // left: 50%;
      // transform: translateX(-50%);
      // bottom: 28px;
  }
}
</style>
